import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b4dadef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "changeNameBox" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "changeMailBox"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "changePhoneBox"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 2,
  class: "serviceType"
}
const _hoisted_10 = { class: "professional" }
const _hoisted_11 = { class: "remaining" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "boxStyle" }
const _hoisted_16 = { class: "boxStyleLeft" }
const _hoisted_17 = { class: "boxStyle" }
const _hoisted_18 = { class: "boxStyleLeft" }
const _hoisted_19 = {
  key: 1,
  class: "mobile-user-center"
}
const _hoisted_20 = { class: "tab-content" }
const _hoisted_21 = { class: "tab-header" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "tab-middle" }
const _hoisted_24 = { class: "amount" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "amount-color" }
const _hoisted_27 = {
  key: 1,
  class: "amount-color"
}
const _hoisted_28 = { class: "tab-bom" }
const _hoisted_29 = {
  key: 0,
  class: "flex"
}
const _hoisted_30 = { style: {"margin-right":"0.2rem"} }
const _hoisted_31 = {
  key: 1,
  class: "flex"
}
const _hoisted_32 = { class: "flex-spc" }
const _hoisted_33 = { class: "flex-spc" }
const _hoisted_34 = { class: "tab-btns" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))

import { ref, computed, onMounted, h } from "vue";
import i18n from "@/lang";
import { ElMessage, ElMessageBox } from "element-plus";
import { useStore } from "vuex";
import { queryServiceLists, changeNickName } from "@/api/userCenter";
import {
  zhEnConversion,
  clipboardSuccess,
  clipboardError,
  logout,
  mobileGotoNext,
} from "@/utils";
import { setLocalStorage } from "@/utils/cookies";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const isMobile = computed(() => store.state.isMobile);
const mobileTabRouters = [
  {
    label: "information.order",
    route: "userCenterAccountOrder",
  },
  {
    label: "information.gift",
    route: "giveService",
  },
  {
    label: "information.account",
    route: "userCenterAccountBill",
  },
  {
    label: "user_center.integral",
    route: "userCenterAccountRewards",
  },
];
const $t = i18n.global.t;
const store = useStore();
const router = useRouter();
// 当前选择语言包
const appLanguage = computed(() => store.state.appLanguage);
// 个人渠道邀请Code码
const invitationCode = computed(() => store.state.userInfo.channelNo);
// 个人渠道分享链接
const invitationUrl = computed(() => store.state.userInfo.channelLink);
// 剩余时长
const currentSurplusTime = computed(
  () => store.state.userInfo.currentSurplusTime
);
// 用户信息
const personalDetails = computed(() => store.state.userInfo);
// reactive<Record<string, string | number | null>>({});
// 昵称
const inputName = ref(personalDetails.value.nickName);

//积分
const scoreBalance = computed(() => store.state.userInfo.scoreBalance);
// 是否正在修改昵称
const changeName = ref(false);
// 多次请求处理
const isDBclick = ref(false);

const handleRecharge = () => {
  router.push({
    name: "purchase-services",
    query: {
      back_path: "personal",
    },
  });
};
//修改昵称
const handleSaveNickName = () => {
  if (!changeName.value && !isDBclick.value) {
    changeName.value = true;
    isDBclick.value = true;
  } else {
    if (!isDBclick.value) return;
    if (inputName.value.length == 0) {
      ElMessage.error(i18n.global.t("user_center.please_nickname"));
      return;
    }
    isDBclick.value = false;
    changeNickName({ nickname: inputName.value }).then((res: any) => {
      if (res.code == 0) {
        ElMessage.success(i18n.global.t("user_center.edit_success"));

        personalDetails.value.nickName = inputName.value;
        changeName.value = false;
        store.commit("setUserInfo", personalDetails.value);
        setLocalStorage("userInfo", personalDetails.value);
      }

      if (res.code == 1) {
        isDBclick.value = true;
      }
      //
    });
  }
};
//查询用户已购服务列表
const productId = ref("");
const personalMessage = () => {
  queryServiceLists().then((res: any) => {
    if (res.code == 0) {
      if (res.data != null) {
        const data = res.data.productServiceVoList[0];
        productId.value = data.productId;
        personalDetails.value.currentSurplusTime = data.currentSurplusTime;
        store.commit("setUserInfo", personalDetails.value);
      }
    }
  });
};
onMounted(() => {
  personalMessage();
});
const handleChangePassword = () => {
  router.push({
    name: "amendPassword",
  });
};
const handleSwitchAccount = () => {
  ElMessageBox({
    message: h("p", null, [
      h(
        "div",
        { style: "padding-bottom: 15px ; padding-top:10px" },
        $t("user_center.quit_login")
      ),
    ]),
    showCancelButton: true,
    confirmButtonText: $t("user_center.confirm"),
    center: true,
    cancelButtonText: $t("user_center.cancel"),
    customClass: "header-dialog",
    beforeClose: (action, instance, done) => {
      if (action === "confirm") {
        logout();
        router.push({
          name: "login",
        });
        done();
      } else {
        done();
      }
    },
  })
    .then((action) => {
      ElMessage({
        type: "success",
        message: $t("user_center.exit_success"),
      });
    })
    .catch((res) => {});
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_CopyDocument = _resolveComponent("CopyDocument")!
  const _component_SecondPageHeader = _resolveComponent("SecondPageHeader")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_Select = _resolveComponent("Select")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _directive_clipboard = _resolveDirective("clipboard")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['box', { mobileSize: _unref(isMobile) }])
  }, [
    (!_unref(isMobile))
      ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
          _createElementVNode("li", _hoisted_2, [
            _createElementVNode("p", null, _toDisplayString(_unref($t)("user_center.nick_name")), 1),
            (!changeName.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                  _createTextVNode(_toDisplayString(_unref(personalDetails).nickName), 1),
                  _createElementVNode("i", {
                    class: "change",
                    onClick: handleSaveNickName
                  })
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _createVNode(_component_el_input, {
                    modelValue: inputName.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputName).value = $event)),
                    class: "w-50 m-2",
                    placeholder: _unref($t)('faq.nickname_place'),
                    onBlur: handleSaveNickName
                  }, null, 8, ["modelValue", "placeholder"]),
                  _createElementVNode("i", {
                    class: "save",
                    onClick: handleSaveNickName
                  })
                ]))
          ]),
          (_unref(personalDetails).email)
            ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                _createElementVNode("p", null, _toDisplayString(_unref($t)("user_center.email")), 1),
                (_unref(personalDetails).email)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(personalDetails).email), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_unref(personalDetails).mobile)
            ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                _createElementVNode("p", null, _toDisplayString(_unref($t)("user_center.iphone")), 1),
                (_unref(personalDetails).mobile)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(personalDetails).mobile), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_unref(personalDetails).serviceType != 4)
            ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", null, _toDisplayString(_unref(zhEnConversion)(_unref(personalDetails).title)), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createTextVNode(_toDisplayString(_unref(appLanguage) === "zh"
                ? _unref(personalDetails).text
                : "Service validity period remaining") + " ", 1),
                    (_unref(personalDetails).serviceType != 3)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                          _hoisted_13,
                          _createElementVNode("b", null, _toDisplayString(_unref(currentSurplusTime)), 1),
                          _createTextVNode("   " + _toDisplayString(_unref(appLanguage) === "zh" ? _unref(personalDetails).time : "months"), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_14, " " + _toDisplayString(_unref(personalDetails).balance), 1))
                  ])
                ]),
                (_unref(personalDetails).serviceType == 1)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      class: "renewBtn",
                      to: '/privilege'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($t)("user_center.top_up")), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(personalDetails).serviceType == 2)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      class: "renewBtn",
                      to: '/privilege'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($t)("user_center.renew")), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("li", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("p", null, _toDisplayString(_unref($t)("user_center.integral")) + "：", 1),
              _createElementVNode("a", null, _toDisplayString(_unref(scoreBalance)) + " " + _toDisplayString(_unref($t)("user_center.integral")), 1),
              _createVNode(_component_el_popover, {
                placement: "top-start",
                title: "",
                width: 200,
                trigger: "hover",
                effect: "dark",
                "popper-class": "bubble",
                content: _unref($t)('user_center.integral_rule')
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_icon, { style: {"margin-left":"10px","cursor":"pointer"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_QuestionFilled)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["content"])
            ]),
            _createVNode(_component_el_button, {
              class: "btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/pointsMall')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref($t)("user_center.Exchange")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("p", null, _toDisplayString(_unref($t)("user_center.invitation_code")) + "：", 1),
              _createElementVNode("div", null, [
                _createElementVNode("a", null, _toDisplayString(_unref(invitationCode)), 1),
                _withDirectives((_openBlock(), _createBlock(_component_el_icon, {
                  style: {"margin-left":"10px","cursor":"pointer"},
                  class: "copy"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CopyDocument)
                  ]),
                  _: 1
                })), [
                  [_directive_clipboard, _unref(invitationCode), "copy"],
                  [_directive_clipboard, _unref(clipboardSuccess), "success"],
                  [_directive_clipboard, _unref(clipboardError), "error"]
                ])
              ])
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_button, { class: "invitationLink btn" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref($t)("user_center.invitation_url")), 1)
              ]),
              _: 1
            })), [
              [_directive_clipboard, _unref(invitationUrl), "copy"],
              [_directive_clipboard, _unref(clipboardSuccess), "success"],
              [_directive_clipboard, _unref(clipboardError), "error"]
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createVNode(_component_SecondPageHeader, {
            title: _unref($t)('user_center.per_center'),
            isShowBackButton: false
          }, null, 8, ["title"]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              (_unref(personalDetails).serviceType != 4)
                ? (_openBlock(), _createElementBlock("i", _hoisted_22, _toDisplayString(_unref(zhEnConversion)(_unref(personalDetails).title)), 1))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, _toDisplayString(_unref(personalDetails).serviceType == 3
                ? _unref($t)("information.termOfValidity")
                : _unref($t)("information.balance")), 1)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                (_unref(personalDetails).serviceType != 3)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                      _createElementVNode("b", _hoisted_26, _toDisplayString(_unref(currentSurplusTime)), 1),
                      _createTextVNode(" " + _toDisplayString(_unref($t)("information.device_months")), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_unref(personalDetails).balance), 1))
              ]),
              _createElementVNode("div", {
                class: "recharge-btn",
                onClick: handleRecharge
              }, _toDisplayString(_unref($t)("information.topUp")), 1)
            ]),
            _createElementVNode("div", _hoisted_28, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(mobileTabRouters, (item, index) => {
                return _createElementVNode("div", {
                  class: "bom-route",
                  key: index
                }, [
                  _createVNode(_component_router_link, {
                    to: {
                name: item.route,
              }
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_unref($t)(item.label)), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              }), 64))
            ])
          ]),
          _createVNode(_component_el_descriptions, {
            class: "user-info-dec",
            column: 1
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_descriptions_item, {
                label: _unref($t)('user_center.nick_name')
              }, {
                default: _withCtx(() => [
                  (!changeName.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(personalDetails).nickName), 1),
                        _createVNode(_component_el_icon, {
                          size: 20,
                          color: "#1CB3FF",
                          onClick: handleSaveNickName
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Edit)
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createVNode(_component_el_input, {
                          modelValue: inputName.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputName).value = $event)),
                          style: {"margin-right":"0.2rem"},
                          placeholder: _unref($t)('faq.nickname_place'),
                          onBlur: handleSaveNickName
                        }, null, 8, ["modelValue", "placeholder"]),
                        _createVNode(_component_el_icon, {
                          size: 20,
                          color: "#1CB3FF",
                          onClick: handleSaveNickName
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Select)
                          ]),
                          _: 1
                        })
                      ]))
                ]),
                _: 1
              }, 8, ["label"]),
              (_unref(personalDetails).mobile)
                ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                    key: 0,
                    label: _unref($t)('user_center.iphone')
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(personalDetails).mobile), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]))
                : _createCommentVNode("", true),
              (_unref(personalDetails).email)
                ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                    key: 1,
                    label: _unref($t)('user_center.email')
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(personalDetails).email), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_descriptions_item, {
                label: _unref($t)('user_center.integral') + '：'
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", null, [
                      _createTextVNode(_toDisplayString(_unref(scoreBalance)) + _toDisplayString(_unref($t)("user_center.integral")) + " ", 1),
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "",
                        style: {"width":"3rem"},
                        trigger: "click",
                        effect: "dark",
                        "popper-class": "bubble",
                        content: _unref($t)('user_center.integral_rule')
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, { style: {"margin-left":"10px","cursor":"pointer"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["content"])
                    ]),
                    _createVNode(_component_el_button, {
                      class: "btn",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push('/pointsMall')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($t)("user_center.Exchange")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_descriptions_item, {
                label: _unref($t)('user_center.invitation_code') + '：'
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", null, [
                      _createTextVNode(_toDisplayString(_unref(invitationCode)) + " ", 1),
                      _withDirectives((_openBlock(), _createBlock(_component_el_icon, {
                        style: {"margin-left":"0.1rem"},
                        class: "copy"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CopyDocument)
                        ]),
                        _: 1
                      })), [
                        [_directive_clipboard, _unref(invitationCode), "copy"],
                        [_directive_clipboard, _unref(clipboardSuccess), "success"],
                        [_directive_clipboard, _unref(clipboardError), "error"]
                      ])
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_el_button, { class: "invitationLink btn" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($t)("user_center.invitation_url")), 1)
                      ]),
                      _: 1
                    })), [
                      [_directive_clipboard, _unref(invitationUrl), "copy"],
                      [_directive_clipboard, _unref(clipboardSuccess), "success"],
                      [_directive_clipboard, _unref(clipboardError), "error"]
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", {
              class: "btn",
              onClick: handleChangePassword
            }, _toDisplayString(_unref(store).state.userInfo.setPassword
              ? _unref($t)("user_center.change_password")
              : _unref($t)("user_center.set_password")), 1),
            _hoisted_35,
            _createElementVNode("div", {
              class: "btn",
              onClick: handleSwitchAccount
            }, _toDisplayString(_unref($t)("login.switch_account")), 1)
          ])
        ]))
  ], 2))
}
}

})